import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Table, Modal} from 'antd'
import {toJS} from 'mobx'
import {DeleteOutlined, EditOutlined, QuestionCircleFilled, SearchOutlined, PlusOutlined} from '@ant-design/icons'
import customerManagementAPI from '../../apis/customerManagement'
import {getPaginationConfig} from '../../components/pagination'
import FormModal from './components/FormModal'
import EditModal from './components/EditModal'
import UPM from '../../constants/urlPermissionMappings'
import {withTranslation} from 'react-i18next'

const {confirm} = Modal

class customerManagement extends Component {
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    addModalVisible: false,
    editModalVisible: false,
    tableData: [],
    id: null
  }
  formRef = React.createRef()

  componentDidMount() {
    this.handleSearch(1, 10)
  }

  handleSearch = (page, size) => {
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        customer: fieldsValue.customer,
        page: page ? page : this.state.page,
        size: size ? size : this.state.size,
      }
      customerManagementAPI.searchAction(params).then(res => {
        this.setState({
          tableData: res.data.data?.records,
          page: res.data.data.current, // 当前页
          size: res.data.data.size, // 每页显示条数
          total: res.data.data.total // 总条数
        })
      })
    }).catch()
  }

  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }

  handleCancel = (target) => {
    this.setState({
      [target]: false
    })
  }

  handlePageChange = (page, pageSize) => {
    // page 目标页
    // pageSize 显示条数
    this.handleSearch(page, pageSize)
  }

  handleEdit = (id) => {
    this.setState({
      editModalVisible: true,
      id
    })
  }

  handleDel = (record) => {
    const {t} = this.props
    let _this = this
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        customerManagementAPI.delAction(record.id).then(() => {
          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {location, t} = this.props
    const pagination = getPaginationConfig(this.state.page, this.state.size, this.state.total, this.handlePageChange)

    return (
      <div className="container">
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col span={6}>
              <Form.Item name="customer" label={t(`customerManagement.customer`)}>
                <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={18} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={() => { this.handleSearch(1, 10) }} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        <Table className="searchResult" dataSource={toJS(this.state.tableData)} rowKey="id" pagination={pagination}
               rowClassName={this.getRowClassName}>
          <Table.Column title={t(`customerManagement.customer`)} dataIndex="customer" key="customer" ellipsis={true}/>
          <Table.Column title={t(`customerManagement.creator`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
          <Table.Column title={t(`customerManagement.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
          <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, record) => {
            return (
              <>
                <Button type="link" onClick={() => this.handleEdit(record.id)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
                <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
              </>
            )
          }}/>
        </Table>
        {this.state.addModalVisible ?
          <FormModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} addModalVisible={this.state.addModalVisible}/> : null}
        {this.state.editModalVisible ? <EditModal handleCancel={this.handleCancel} handleSearch={this.handleSearch} id={this.state.id}
                                                  editModalVisible={this.state.editModalVisible}/> : null}
      </div>
    )
  }
}

export default withTranslation()(customerManagement)
